import http from '../http'

export default {
    prospects(usuario) {
        return http.get(`/usuarios/${usuario}/sadasi/prospects`)
    },
}